const prefix = 'forms'

export const FormsQueryKeys = {
  AvailableForms: `${prefix}/available-forms`,
}
